<template>
  <div class="pg-index stop-swiping" :class="star" ref="index">
    <div class="pg-header"></div>
    <!-- <div class="pg-bottom"></div> -->
    <div class="main-swiper swiper-container">
      <div class="swiper-wrapper" ref="wrapper">
        <!-- p1 -->
        <div class="swiper-slide p1" ref="p1">
          <!-- <div class="logo"></div> -->
          <div class="btn-wrap" :class="star">
            <div class="times">剩余抽奖次数:<span class="emphsis">{{chance}}</span></div>
            <div class="draw" :class="star" @click="lotto"></div>
          </div>
          <div class="btn-wrap btn-wrap-2">
            <div class="times times-call">召集<span class="emphsis">1位</span>兄弟,增加<span class="emphsis">1次</span>抽奖机会</div>
            <div class="call" :class="star" @click="callFriend"></div>
            <!-- <div class="call-times">还可以召集{{userInfo.weixin_state ? userInfo.invitablenum : 4}}名兄弟</div> -->
          </div>
          <div class="lucky" :class="star">
            <autoScroll :list.sync="luckyList" :config="config">
              <template v-slot="vData">
                <!-- 数据渲染列表 -->
                <li v-for="(item, index) in vData.vDota" :key="index" class="iztVnode-item" :style="{ height: vData.config.itemHeight + 'px',lineHeight: vData.config.itemHeight + 'px' }">
                  <span class="lucky-name">{{item.nickname}}</span>&nbsp;&nbsp;已抽到&nbsp;&nbsp;<span class="lucky-prize">{{item.item_name}}</span>
                </li>
              <!-- 数据渲染列表 -->
              </template>
            </autoScroll>
          </div>

          <div class="frame" :class="star">
            <div class="frame-bg" :class="star">
              <div class="icon" @click="showDesc()"></div>
              <div class="frame-title" :class="star"></div>
              <div class="prize-wrapper swiper-container prize-swiper" :class="star">
                <div class="swiper-wrapper">
                  <div class="swiper-slide frame-slide"  v-for="(item, index) in prize" :key="index">
                    <Prize v-for="(prize, pIndex) in item" :key="pIndex" :prize="prize.icon" :name="prize.name"></Prize>
                  </div>
                </div>
              </div>
              <div class="swiper-pagination prize-pagination" :class="star">
              </div>
            </div>
            <div class="wx" @click="showWx()"></div>
          </div>

          <div class="slide-prev" @click="slidePrev"></div>
          <div class="slide-prev next" @click="slideNext"></div>

        </div>
        <!-- p2 -->
        <div class="swiper-slide p2" ref="p2">
          <div
            class="get"
            :class="[star, (!prizeList.list || prizeList.list.some(x => x.state) && userInfo.charname || !candraw) ? 'disabled' : '']"
            @click="getPrize"
          ></div>
          <div class="bind" :class="[star,userInfo.isbind || !candraw ? 'disabled' : '']" @click="bindRole"></div>
          <div v-if="userInfo.isbind" class="role" :class="star">
            <span class="role-title">已绑定角色：</span>
            <span class="role-name">{{userInfo.charname}}</span>
          </div>
          <Frame
            class="big-frame"
            :class="star"
            :height="((star === 'gaoye' || star === 'lv') && (prizeHeight + 32) < 500 ? 500 : (prizeHeight + 32))/100 + 'rem'"
          >
            <div v-if="!prizeList.list || !prizeList.list.length" class="none">暂无奖励</div>
            <div v-else class="desc">点击图标，<span style="color: #c21000">选择10种</span>想要领取的奖励</div>
            <div v-if="prizeList.realinfo" class="address" @click="handleAddress">填写地址</div>
            <div class="prize-wrapper" :class="star">
              <Prize
                v-for="(prize, index) in prizeList.list"
                :key="index"
                :prize="prize.icon"
                :name="prize.title"
                :drawed="prize.state"
                :id="prize.id"
                :choosed="myPrize.length ? myPrize.some(x => x.id === prize.id) : false"
                :can-draw="!prize.state && prizeList.list && !prizeList.list.some(x => x.state) && myPrize.length < 10"
                @toggle="togglePrize"
              >
              </Prize>
            </div>
          </Frame>
        </div>
      </div>
    </div>
    <div class="header">
      <div class="game_icon"></div>
      <div class="game_button fr">
        <a href="/download" class="bt-download"></a>
        <!-- <a href="" class="bt-download ios"></a> -->
        <a href="/index.shtml" class="home"></a>
      </div>
    </div>
    <a class="nav" href="/act/jnh2024/"></a>
    <div class="slogan slideInDown animated"></div>
    <div class="swiper-pagination main-pagination">
      <div
        class="swiper-pagination-bullet"
        :class="[
          `swiper-pagination-bullet-${index + 1}`,
          activeIndex === index ? 'active' : ''
        ]"
        v-for="(item, index) in bullets"
        :key="index"
        @click="slideTo(index)"
      >
      </div>
    </div>
  </div>
</template>
<script>
import store from "~/store/index";
import * as types from "~/store/mutation-type";
import { mapState } from "vuex";
import { isWeiXin, getParameterByName, isAndroid, setCookie, getCookie, deleteCookie, setCookieByDays } from "~/tools/utils";
import autoScroll from "~/components/autoScroll.vue";
import Alert from "~/components/Alert";
import confirm from "~/components/Confirm";
import affirm from "~/components/Affirm";
import Frame from "~/components/Frame/frame.vue";
import Prize from "~/components/Prize/index.vue";
import api from "~/api/api";
import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";
// import IScroll from 'iscroll/build/iscroll-probe'
// import Help from "~/components/Help";

export default {
  components: {Prize, Frame, autoScroll},
  data() {
    return {
      candraw: true,
      star: 'zhounian',
      mtag: getParameterByName('mtag'),
      isAndroid: isAndroid(),
      isEditing: false,
      loggedIn: false,
      account: "",
      bullets: [
        "十连抽奖",
        "我的奖励",
        "活动规则"
      ],
      prize: [
        [
          {icon: 31, name: '升级宝石*5000'},
          {icon: 32, name: '超级锦鲤大礼包'},
          {icon: 30, name: '限定外观'},
          {icon: 29, name: '坐骑礼包'},
          {icon: 28, name: '专属称号'},
          {icon: 27, name: '高阶令牌组合'},
          {icon: 26, name: '升级宝石*10'},

        ],
        [
          {icon: 25, name: '材料助力礼包'},
          {icon: 24, name: '魂魄助力礼包'},
          {icon: 23, name: '成长助力礼包'},

          {icon: 4, name: '天香蜜露'},
          {icon: 22, name: '三等硬皮*5'},
          {icon: 21, name: '三等秘银*5'},

          {icon: 20, name: '二等硬皮*5'},
          {icon: 19, name: '二等秘银*5'},
          {icon: 16, name: '竹蜻蜓 *10'},
          {icon: 12, name: '1两银子 *50'},

        ],
        [
          {icon: 10, name: '隐身符 *10'},
          {icon: 6, name: '回城卷 *10'},
          {icon: 3, name: '大还丹 *99'},

          {icon: 18, name: '一等硬皮*5'},
          {icon: 17, name: '一等秘银*5'},
          {icon: 15, name: '竹蜻蜓 *5'},
          {icon: 14, name: '蓝色培训令牌*2'},
          {icon: 13, name: '蓝色押镖令*2'},
          {icon: 11, name: '1两银子 *25'},
          {icon: 9, name: '隐身符 *5'}
        ],
        [
          {icon: 8, name: '白色培训令牌*5'},
          {icon: 7, name: '白色押镖令*5'},
          {icon: 5, name: '回城卷 *5'},
          {icon: 2, name: '大还丹 *50'},
          {icon: 1, name: '大还丹 *25'}
        ]
      ],
      myPrize: [],
      mgplayer: {},
      swiper: {},
      prizeSwiper: {},
      downUrl:'',
      wxtitle: "《原始征途》嘉年华至尊百连抽",
      wxdesc: `免费抽终极豪礼，时装坐骑任选，更有专属锦鲤大奖！`,
      wximages: "https://" + window.location.host + "/act/blc_carnival2024/share.jpg",
      matchList: [],
      prviousIndex: 0,
      activeIndex: 0,
      prizeActiveIndex: 0,
      ingame: getParameterByName("ingame"),
      luckyList: [],
      config: {
        itemHeight: 36 * window.innerWidth / 750, // 滚动行高度 默认50
        sCro: 1, // 默认为0:禁止自动上下滚动
        startsCro: 1, // 控制什么时候开始 1
        overFlow: 1 // 0不允许手指或者鼠标滑动  默认1
      }
    };
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo,
      chance: state => state.chance,
      prizeList: state => state.prizeList,
      modal: state => state.modal
    }),
    prizeHeight() {
      let height =  (this.prizeList.list ? this.prizeList.list.length : 0) * 173/5 + 128
      if(this.prizeList.list && this.prizeList.list.some(x => x.icon === 31)) {
        height += 173
      }
      return height
    },
    hasChance() {
      let hasChance = !this.prizeList || !this.prizeList.list || this.prizeList.list.length < 180
      return hasChance
    }
  },
  mounted() {
    // store.commit(types.SHOW_MODAL, {type: 'times'})
    // store.commit(types.SHOW_MODAL, {type: 'noChance'})
    // store.commit(types.SHOW_MODAL, {type: 'bind'});
    // Help("助力成功！<br>你也去抽个十连试试手气吧！")
    // store.commit(types.SHOW_MODAL2, {type: 'material', material: 'piying'})
    // store.commit(types.SHOW_MODAL2, {type: 'address'})
    // store.commit(types.SHOW_MODAL, {type: 'copy', copy: window.location.origin + `/act/blc_carnival2024/#/?star=zhounian&fid=2`})
    // if(!isWeiXin()) {
    //   Alert("请在微信中打开")
    // }
    // confirm([], []);
    // affirm("test1")
    // Alert('领取成功，<br>奖励将在15分钟内发送至游戏中，<br>请及时查收');
    // Alert("绑定成功！<br>现在可以领取奖励啦！", 'draw')
    // store.commit(types.SHOW_MODAL2, {type: 'material', material: 'switch'})

    // let url = `https://yszt.ztgame.com/download/${this.isAndroid ? 'android' : 'ios'}.html`
    // store.commit(types.SHOW_MODAL, {type: 'times', copy: 'https://lh.web.ztgame.com/act/blc_zhounian/#/share?fid=2'})
    // TODO 测试弹窗 需去掉
    // store.commit(types.SHOW_MODAL, {type: 'win', win: [
    //   {id: 31, title: "锦鲤宝石包", icon: 31},
    //   {id: 20, title: "隐身符*5", icon: 9},
    //   {id: 12, title: "大还丹*50", icon: 2},
    //   {id: 19, title: "二等硬皮*5", icon: 20},
    //   {id: 16, title: "大还丹*25", icon: 1},
    //   {id: 18, title: "蓝色培训令牌*2", icon: 14},
    //   {id: 15, title: "魂魄助力礼包", icon: 24},
    //   {id: 13, title: "大还丹*25", icon: 1},
    //   {id: 14, title: "竹蜻蜓*5", icon: 15},
    //   {id: 11, title: "一等硬皮*5", icon: 18}
    // ]});
    const _this = this;

    // 纪录私域流量数据 Cookie
    if(!getCookie('star')) {
      setCookieByDays('star', this.star, 90);
    }
    if(this.mtag && !getCookie('mtag')) {
      setCookieByDays('mtag', this.mtag, 90);
    }

    requirejs(["weixin/main", "downloadway/main", 'login/index', "jquery", 'yuyue/index'], (weixin, Download, gLogin, $, YUYUE) => {
      // window.setShare = setShare
      var appid = 'wx0fcf7f47419c8171';

      window.yuyue = new YUYUE({
        dev: {
          cid: 87,
        },
        cid: 76,
        selectPlatform: false,
        from: 'blc_gaoye'
      });

      if(!_this.ingame) {
        window.Download = Download
      }

      window.glogin = new gLogin({
          type:'popup',
          menu_idx: 'smcd|account',
          //设置 去注册按钮
          fastreg:{
              //注意：不支持回调函数
          },
          login_type: 17,
          onLogin:function(result,fromeCookie,fromReg){
              if(fromeCookie){
                  console.log('从cookie自动登录');
                  if(!_this.userInfo.charname) {
                    glogin.logout();
                    return
                  }
                  store.commit(types.UPDATE_USER, Object.assign({}, _this.userInfo, {loggedIn: true}));
              }
              //if(fromReg){
                  //console.log('新注册用户');
              //}
              if(!!result&&!!result.account){
                  //登录成功
                  //alert('登录成功');
                  store.commit(types.UPDATE_USER, Object.assign({}, _this.userInfo, {loggedIn: true}));
                  if(!_this.userInfo.charname && _this.userInfo.toBind) {
                    store.commit(types.SHOW_MODAL, {type: 'bind'});
                  }
              }
              else{
                  //登录失败
                  Alert(result.msg);
              }
          }
      });

      api.getUserInfo().then(res => {
        if(res.status === 1) {
          // this.candraw = /web.ztgame.com/.test(location.href) || res.open_state === 1
          store.commit(types.UPDATE_USER, res);
          store.commit(types.UPDATE_CHANCE, res.chance);
          let action = getCookie('action');
          if(action) {
            _this[action]();
          }
          if(res.weixin_state) {
            console.log(`重设分享链接`);
            window.wx = new weixin(appid,() => {
              //朋友圈
              let link = window.location.origin + `/act/blc_carnival2024/#/share?fid=${res.shareinfo.userid}`
              if(_this.mtag) {
                link += `&mtag=${_this.mtag}`
              }
              wx.onMenuShareTimeline({
                  title: `${res.shareinfo.nickname}邀请你助力《原始征途》嘉年华至尊百连抽，5000升级宝石免费送`, // 分享标题
                  link, // 分享链接
                  imgUrl: this.wximages
              });
              //朋友
              wx.onMenuShareAppMessage({
                  title: `${res.shareinfo.nickname}邀请你助力《原始征途》嘉年华至尊百连抽，5000升级宝石免费送`, // 分享标题
                  desc: this.wxdesc, // 分享描述
                  link, // 分享链接
                  imgUrl: this.wximages, // 分享图标
                  type: 'link' // 分享类型,music、video或link，不填默认为link
              });
              if(this.ingame) {
                window.wx.miniProgram.postMessage({data: { fid: res.shareinfo.userid, star: this.star }});
              }
            });
            document.querySelector(".pg-loading").style.display = "none";
            return api.getPrizeList();
          } else {
            window.wx = new weixin(appid,() => {
              //朋友圈
              wx.onMenuShareTimeline({
                  title: `${res.shareinfo.nickname}邀请你助力《原始征途》嘉年华至尊百连抽，5000升级宝石免费送`, // 分享标题
                  link: window.location.href, // 分享链接
                  imgUrl: this.wximages
              });
              //朋友
              wx.onMenuShareAppMessage({
                  title: `${res.shareinfo.nickname}邀请你助力《原始征途》嘉年华至尊百连抽，5000升级宝石免费送`, // 分享标题
                  desc: this.wxdesc, // 分享描述
                  link: window.location.href, // 分享链接
                  imgUrl: this.wximages, // 分享图标
                  type: 'link' // 分享类型,music、video或link，不填默认为link
              });
            });
          }
        } else {
          window.wx = new weixin(appid,() => {
            //朋友圈
            wx.onMenuShareTimeline({
                title: `${res.shareinfo.nickname}邀请你助力《原始征途》嘉年华至尊百连抽，5000升级宝石免费送`, // 分享标题
                link: window.location.href, // 分享链接
                imgUrl: this.wximages
            });
            //朋友
            wx.onMenuShareAppMessage({
                title: `${res.shareinfo.nickname}邀请你助力《原始征途》嘉年华至尊百连抽，5000升级宝石免费送`, // 分享标题
                desc: this.wxdesc, // 分享描述
                link: window.location.href, // 分享链接
                imgUrl: this.wximages, // 分享图标
                type: 'link' // 分享类型,music、video或link，不填默认为link
            });
          });
        }
        document.querySelector(".pg-loading").style.display = "none";
      }).then(res => {
        if(res && res.status === 1) {
          let list = res.list.reduce((a, b) => a.concat(b), []);
          // TODO 需删除数据处理
          // list[0] = {id: 2, title: "锦鲤宝石包", icon: 31, state: 0}

          let prizeList = Object.assign({}, this.prizeList, {
            list: list,
            realinfo: res?.realinfo?.item_name === "未中奖" ? '' : res?.realinfo?.item_name
          })
          store.commit(types.UPDATE_PRIZE, prizeList);
          // debugger
          // 测试弹窗，续注释掉
          // prizeList.list.push({
          //   icon: 31,
          //   id: 888,
          //   state: 0,
          //   title: "升级宝石*5000"
          // })
          // confirm(prizeList.list.slice(0, 10), prizeList)
        }
      }).catch(err => {
        document.querySelector(".pg-loading").style.display = "none";
      });
    })

    try {
      let baseOption = {
        allowTouchMove: true,
        slidesPerView: 'auto',
        spaceBetween: 0,
        preventInteractionOnTransition: true,
        autoHeight: true
      }

      this.prizeSwiper = new Swiper(".prize-swiper", Object.assign({}, baseOption, {
        speed: 600,
        loop: true,
        direction: 'horizontal',
        pagination: {
          el: '.prize-pagination',
        }
      }));
    } catch (error) {
      console.log(error);
    }
    this.$refs.wrapper.style.height = 1884*window.innerWidth/750 > window.innerHeight ? '8.79rem' : 'calc(100vh - 8.35rem)'

    api.getLuckyList().then(res => {
      if(res && res.status === 1) {
        this.luckyList = res.list
      }
    });

    // 轮询抽奖次数
    setTimeout(() => {
      this.getScheduleStatus()
    }, 4e3);
  },
  watch:{
    'prizeList.list': {
      handler: function (newValue) {
        if(newValue && newValue.length && !newValue.some(x => x.state)) {
          this.myPrize = newValue.slice(0, 10)
        } else {
          this.myPrize = []
        }
      },
      deep: true
    },
    'userInfo.toDraw': {
      handler: function (newValue) {
        if(newValue) {
          this.getPrize()
        }
      }
    },
    'userInfo.toSlide': {
      handler: function (newValue) {
        if(newValue) {
          this.slideTo(1)
        }
      }
    },
    'userInfo.action': {
      handler: function (newValue) {
        if(newValue) {
          this[newValue]()
        }
      }
    }
  },
  methods: {
    handleAddress() {
      store.commit(types.SHOW_MODAL2, {type: "address"});
    },
    getScheduleStatus() {
      api.getUserInfo().then(res => {
        if(res.status === 1) {
          store.commit(types.UPDATE_CHANCE, res.chance);
        }
      }).finally(() => {
        setTimeout(() => {
          this.getScheduleStatus()
        }, 4e3);
      });
    },
    iosHandler() {
      _paq.push(['trackEvent', 'BLC-Download', 'Home', 'ios', 'ios'])
    },
    showWx() {
      store.commit(types.SHOW_MODAL, {type: 'wx'})
    },
    showDesc() {
      store.commit(types.SHOW_MODAL, {type: 'desc'})
    },
    downloadHandler() {
      let platform = this.isAndroid ? 'android' : 'ios'
      _paq.push(['trackEvent', 'BLC-Download', 'Home', platform, platform])
      if(this.ingame) {
        let url = `https://yszt.ztgame.com/download/${platform}.html`
        store.commit(types.SHOW_MODAL, {type: 'copy', copy: url})
      }
    },
    togglePrize({checked, id, icon, name}) {
      if(checked) {
        this.myPrize.push({id, icon, name})
      } else {
        this.myPrize = this.myPrize.filter(x => x.id !== id)
      }
    },
    prizeSwiperSlide(index) {
      this.prizeActiveIndex = index
      this.prizeSwiper && this.prizeSwiper.slideTo(index, 600, 0)
    },
    slidePrev() {
      this.prizeSwiper && this.prizeSwiper.slidePrev()
    },
    slideNext() {
      this.prizeSwiper && this.prizeSwiper.slideNext()
    },
    lotto() {
      setCookie('action', 'lotto');
      if(!this.checkLoginStatus()) {
        return
      }
      deleteCookie('action')
      if(!this.hasChance) {
        // 10次机会用完
        store.commit(types.SHOW_MODAL, {type: 'noChance'})
        return
      }
      if(!this.chance) {
        // Alert("召集兄弟增加次数，<br>每召集一个兄弟增加一次")
        store.commit(types.SHOW_MODAL, {type: 'times'})
        return
      }
      if(this.loading) {
        return
      }
      store.commit(types.SHOW_LOADING, true)
      this.loading = true;
      let lottoRes;
      api.lotto().then(res => {
        if(res.status === 1) {
          store.commit(types.UPDATE_CHANCE, this.chance - 1);
          lottoRes = res;
          return api.getPrizeList();
        }
      }).then(res => {
        if(res && res.status === 1) {
          let prizeList = {
            list: res.list.reduce((a, b) => a.concat(b), [])
          }
          if(lottoRes.realinfo && lottoRes.realinfo.item_name) {
            prizeList = Object.assign({}, prizeList, {
              realinfo: lottoRes.realinfo.item_name
            })
          }
          store.commit(types.UPDATE_PRIZE, Object.assign({}, this.prizeList, prizeList));
        }
        this.$nextTick(async () => {
          if(this.prizeList && this.prizeList.list && this.prizeList.list.length === 10) {
            await this.openGif()
          }
          store.commit(types.SHOW_MODAL, {type: 'win', win: [...lottoRes.info.item_detail]});
          // 根据结果判断是否展示实物奖
          if(lottoRes.realinfo && lottoRes.realinfo.item_name) {
            setTimeout(() => {
              store.commit(types.SHOW_MODAL2, {type: 'material', material: lottoRes.realinfo.item_name})
            }, 1896);
          }
        })
        store.commit(types.SHOW_LOADING, false);
        this.loading = false;
      }).catch(() => {
        store.commit(types.SHOW_LOADING, false)
        this.loading = false;
      })
    },
    openGif() {
      return new Promise((resolove) => {
        store.commit(types.SHOW_MODAL, {type: 'open'})
        setTimeout(() => {
          resolove()
        }, 2000)
      })
    },
    callFriend() {
      setCookie('action', 'callFriend');
      if(!this.checkLoginStatus()) {
        return
      }
      deleteCookie('action')
      if(!this.hasChance) {
        // 10次机会用完
        store.commit(types.SHOW_MODAL, {type: 'noChance'})
        return
      }
      let url = `${this.userInfo.shareinfo.nickname}邀请你助力《原始征途》嘉年华至尊百连抽，5000升级宝石免费送：`
      store.commit(types.SHOW_MODAL, {type: 'copy', copy: url + window.location.origin + `/act/blc_carnival2024/#/share?fid=${this.userInfo.shareinfo.userid}`})
      // if(this.ingame) {
      // } else {
      //   store.commit(types.SHOW_MODAL, {type: 'share'});
      // }
    },
    slideTo(index) {
      if(index === 2) {
        store.commit(types.SHOW_MODAL, {type: 'rule'})
        return
      }
      if(index === this.activeIndex) {
        return
      }
      if(index === 1 && !this.userInfo.weixin_state) {
        let url = `/act/blc_carnival2024/api/api.php?c=index&a=wxauth`;
        if(this.mtag) {
          url += `&mtag=${this.mtag}`
        }
        if(/web.ztgame.com/.test(location.href)) {
          url = `https://yszt.web.ztgame.com/act/blc_carnival2024/api/api.php?c=index&a=wxauth`
          if(this.mtag) {
            url += `&mtag=${this.mtag}`
          }
        }
        if(this.ingame) {
          url += '&ingame=ingame'
        }
        location.replace(url)
        return
      }
      this.previousIndex = this.activeIndex
      this.activeIndex = index
      switch (this.activeIndex) {
        case 0:
          this.$refs.wrapper.style.height = 1884*window.innerWidth/750 > window.innerHeight ? '8.79rem' : 'calc(100vh - 8.35rem)'
          if(this.prizeHeight + 32 > 500) {
            this.$refs.index.style.height = 1884*window.innerWidth/750 > window.innerHeight ? '19.24rem' : '100vh'
          }
          break;
        case 1:
          store.commit(types.UPDATE_USER, Object.assign({}, this.userInfo, {toSlide: false}));
          let height = this.prizeHeight + 32 + 225 + 114
          this.$refs.p2.style.height = this.$refs.wrapper.style.height = this.prizeHeight + 32 > 500 ? ((height + 6)/100 + 'rem') : '9.41rem'
          if(this.prizeHeight + 32 > 500) {
            this.$refs.index.style.height = (height + 975 + 10 + 6)/100 + 'rem'
          }
          break;
        default:
          break;
      }
      this.$refs.wrapper.style.transitionDuration = '0.6s'
      this.$refs.wrapper.style.transform = `translateX(${-this.activeIndex * 100}%)`
    },
    checkLoginStatus() {
      if(!this.userInfo.weixin_state) {
        let url = `/act/blc_carnival2024/api/api.php?c=index&a=wxauth`;
        if(this.mtag) {
          url += `&mtag=${this.mtag}`
        }
        if(/web.ztgame.com/.test(location.href)) {
          url = `https://yszt.web.ztgame.com/act/blc_carnival2024/api/api.php?c=index&a=wxauth`
          if(this.mtag) {
            url += `&mtag=${this.mtag}`
          }
        }
        if(this.ingame) {
          url += '&ingame=ingame'
        }
        location.replace(url)
        return false;
      }
      return true
    },
    bindRole() {
      // if(!this.candraw) {
      //   Alert("未到领奖时间，请在《原始征途》<br>3月24日嘉年华后前来领取奖励");
      //   return;
      // }
      if(!this.userInfo.charname) {
        if(this.userInfo.loggedIn) {
          store.commit(types.SHOW_MODAL, {type: 'bind'});
          return;
        }
        glogin.login();
        store.commit(types.UPDATE_USER, Object.assign({}, this.userInfo, {toBind: true}));
      } else {
        Alert("您已绑定过角色，无需重复绑定");
      }
    },
    async getPrize() {
      // if(!this.candraw) {
      //   Alert("未到领奖时间，请在《原始征途》<br>3月24日嘉年华后前来领取奖励");
      //   return;
      // }
      store.commit(types.UPDATE_USER, Object.assign({}, this.userInfo, {toDraw: false}));
      if(!this.userInfo.charname) {
        if(this.userInfo.loggedIn) {
          store.commit(types.SHOW_MODAL, {type: 'bind'});
          return;
        }
        glogin.login();
        store.commit(types.UPDATE_USER, Object.assign({}, this.userInfo, {toBind: true}));
        return;
      }
      if(!this.prizeList.list || !this.prizeList.list.length) {
        Alert("暂无可领取的奖励");
        return;
      }
      if(this.prizeList.list.some(x => x.state)) {
        Alert("您已领奖");
        return;
      }
      if(this.myPrize.length < 10) {
        Alert("请选择10个奖励进行领取");
        return;
      }
      await confirm(this.myPrize, this.prizeList);
      if(this.loading) {
        return
      }
      this.loading = true;
      api.draw(this.myPrize.map(x => x.id)).then(res => {
        if(res.status === 1) {
          Alert('领取成功，<br>奖励将在15分钟内发送至游戏中，<br>请及时查收');
          this.prizeList.list.map(x => {
            if(this.myPrize.some(prize => x.id === prize.id)) {
              x.state = 1
            }
            return x;
          });
          store.commit(types.UPDATE_USER, this.userInfo)
        }
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      })
    },
    goHome() {
      location.href = "/index.shtml"
    }
  },
};
</script>
<style rel="stylesheet/stylus" lang="stylus" scoped>
@font-face{
    font-family: fzshjt;
    src: url('./fzshjt.TTF')
}
.pg-index
  position: relative
  width: 7.5rem
  // background-color #320705
  padding-top 8.79rem
  background-image: url('./images/repeat.jpg')
  background-size: 7.5rem 0.05rem
  overflow hidden
  .pg-header
    position absolute
    top 0
    width 100%
    height 16.29rem
    background-image: url('./images/header.jpg')
    background-size: 100% 100%
  .pg-bottom
    position absolute
    bottom: 0
    bottom: constant(safe-area-inset-bottom)
    bottom: env(safe-area-inset-bottom)
    width 100%
    height 5.01rem
    // background-image: url('./images/bottom.png')
    background-size: 100% 100%
  .slogan
    position absolute
    top 5.75rem
    left 0.37rem
    width 7.03rem
    height 2.68rem
    background-image: url('./images/slogan.png')
    background-size: 100% 100%
  .nav
    position absolute
    top 2rem
    right 0.05rem
    width 0.45rem
    height 2.04rem
    background-image: url('./images/nav.png')
    background-size: 100% 100%
  .emphsis
    color #ffc100
    font-weight bold
  .header
    position: fixed
    top 0
    left 0
    width: 100%;
    height: 1.04rem;
    display: block;
    z-index 2
    background-color rgba(0,0,0,0.75)
    .game_icon
      margin: 0.09rem 0 0 0.27rem;
      width: 2.16rem;
      height: 0.86rem;
      background: url(https://yszt.ztgame.com/assets/logo.png) no-repeat;
      background-size: 100% auto;
    .game_button {
      position: absolute;
      right: 0.3rem;
      top: 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 100%;
      width 3.45rem
      .bt-download {
        width: 1.61rem;
        height: 0.57rem;
        background: url(./images/gaoye/download.png) no-repeat;
        background-size: 100% 100%;
        &.android {
          background-image: url(./images/gaoye/download.png)
        }
        &.ios {
          background-image: url(./images/gaoye/download.png)
        }
      }

      .home {
        display: block;
        width: 1.61rem;
        height: 0.57rem;
        background: url(./images/gaoye/home.png) no-repeat;
        background-size: 100% 100%;
      }
    }
  .login
    position absolute
    top 3.23rem
    width 100%
    text-align center
    color #ffffe1
    font-size 0.22rem
    line-height 1
    z-index 1
    .name
      color #fb794c
    .link
      color #ffffe1
      text-decoration underline
  .human
    position: absolute
    top: 1.45rem
    left: 0
    width: 2.03rem
    height: 2.26rem
    background-image: url('./images/human.png')
    background-size: contain
    // transform-origin: top left
    animation: slideInLeft 0.5s linear
  .ball
    position: absolute
    top: 1.82rem
    left: 1.44rem
    width: 0.73rem
    height: 0.73rem
    background-size: contain
    animation: rotate 1.5s linear infinite
  .prize
    position: absolute
    top: 4.15rem
    width: 0.5rem
    height: 1.22rem
    background-image: url('./images/prize.png')
    background-size: 100% 100%
    z-index 1
  .share
    position: absolute
    top: 5.61rem
    width: 0.5rem
    height: 1.22rem
    background-image: url('./images/share.png')
    background-size: 100% 100%
    z-index 1
  .name
    position absolute
    top 1.88rem
    left 5.73rem
    width 0.89rem
    height 2.28rem
    animation slideInRight 1s ease
  .main-swiper {
    width: 100%
    padding-bottom: constant(safe-area-inset-bottom)
    padding-bottom: env(safe-area-inset-bottom)

    .swiper-slide {
      min-height: calc(100vh - 8.57rem + constant(safe-area-inset-bottom));
      min-height: calc(100vh - 8.57rem + env(safe-area-inset-bottom));
      height: auto;
      .tit {
        position: absolute
        top: 1.15rem
        left: 50%
        width: 6.09rem
        height: 1.49rem
        background-size: 100% 100%
        transform: translateX(-50%)
      }
      .sub-title {
        position: absolute
        top 2.53rem
        color: #ce4e27
        text-align: center
        width 100%
        font-style: normal
        font-size: 0.26rem
        &-3,&-4,&-5,&-6 {
          letter-spacing 0.15rem
        }
      }
      .slide-button {
        outline: none;
        position absolute
        z-index 2
        top 50%
        margin-top -0.13rem
        width 0.37rem
        height 0.7rem
        background:url(./images/m/leftArrow.png) no-repeat;
        background-size contain
        cursor pointer
        &-prev {
          left 0.27rem
        }
        &-next {
          right 0.27rem
          margin-left 5.67rem
          transform rotate(180deg)
        }
      }

      .big-frame {
        position absolute
        top 2.01rem
        left 0.3rem
        min-height: 4.64rem;
        &.lv {
          top 3.01rem
          left 0.37rem
          min-height: 4.64rem;
        }
      }

      &.p1 {
        height: 15.64rem
        height: calc(15.64rem + constant(safe-area-inset-bottom))
        height: calc(15.64rem + env(safe-area-inset-bottom))
        .lucky {
          position absolute
          top 1.59rem
          width 100%
          text-align center
          font-size 0.22rem
          line-height 0.36
          height 0.36rem
          color: #fc6307
          &.zhounian {
            color: #fc6307
            .lucky-prize {
              color #ffc75a
            }
            .lucky-name {
              color #fef0d3
            }
          }
          &-prize {
            font-weight bold
            color: #a300f7
          }
          &-name {
            font-weight bold
            color: #ffe8a2
          }
          /deep/.iztVnode-item {
            font-size 0.24rem
          }
        }
        .logo {
          position absolute
          top 0.2rem
          left 0.13rem
          width 1.23rem
          height 1.14rem
          background:url(./images/logo.png) no-repeat;
          background-size contain
        }
        .btn-wrap {
          width: 3.41rem
          height: 1.66rem
          position: absolute
          top 0
          left 0.37rem
          animation slideInLeft 1s ease forwards
          animation-delay 0.5s
          transform translateX(-100%)
          display flex
          flex-direction column
          align-items center
          &-2 {
            left 3.9rem
            transform translateX(100%)
            animation-name slideInRight
          }
          .times {
            text-align center
            font-size 0.20rem
            color: #fff
            line-height: 0.36rem
            width 2.15rem
            height 0.36rem
            border-radius 0.165rem
            background-color #2f0b0a
            margin-bottom 0.14rem
            &-call {
              width: 3.15rem
            }
          }
          .call-times {
            margin-left: 0.13rem
            width 2.81rem
            height 0.36rem
            margin-top -0.03rem
            text-align center
            font-size 0.22rem
            color: #fffefe
            line-height: 0.36rem
            border-radius 0.165rem
            background-color #d23325
          }
          .draw {
            width 3.41rem
            height 1.16rem
            background:url(./images/draw.png) no-repeat;
            background-size 100% 100%
          }
          .call {
            width 3.41rem
            height 1.16rem
            background:url(./images/call.png) no-repeat;
            background-size contain
            // padding-top 1.36rem
            text-align center
            color #a36c3e
            line-height 1
            font-weight bold
            font-size 0.18rem
          }
        }
        .slide-prev {
          position absolute
          top 5.14rem
          left 0.07rem
          width 0.26rem
          height 0.5rem
          background:url(./images/prev.png) no-repeat;
          background-size contain
          &.next {
            transform rotate(180deg)
            left auto
            right 0.07rem
          }
        }
        .icon {
          position absolute
          left 5.62rem
          top -0.15rem
          width 1.56rem
          height 1.47rem
          background:url(./images/icon.png) no-repeat;
          background-size contain
          z-index 2
        }
        .wx {
          position absolute
          left 6.41rem
          top: 4.71rem
          width 0.89rem
          height 1rem
          background:url(./images/qw.png) no-repeat;
          background-size contain
          z-index 2
        }
        .frame {
          height 5.57rem
          position absolute
          z-index 2
          left 0.15rem
          top 1.96rem
          width 7.13rem
          &-slide {
            background none
            min-height 3.46rem
            padding-left: 0.1rem
            display flex
            flex-wrap wrap
          }
          .frame-bg {
            width 100%
            height 5.57rem
            background:url(./images/frame.png) no-repeat;
            background-size 100% 100%
          }
          .frame-title {
            position absolute
            left 1.6rem
            top 0.55rem
            width 3.99rem
            height 0.95rem
            background: url(./images/gaoye/prize-title.png) no-repeat;
            background-size 100% 100%
          }
          .prize-wrapper {
            position absolute
            top: 1.48rem
            left: 0.64rem
            width: 6.05rem
            height: 3.46rem;
          }
        }
      }

      &.p2 {
        .prize-wrapper {
          padding: 0.24rem 0 0.24rem 0.58rem;
          display flex
          flex-wrap wrap
          &.lv {
            padding-left 0.5rem
          }
        }
        .none {
          font-size 0.3rem
          text-align center
          color #333
          margin-top 0.77rem
        }
        .address {
          position absolute
          left: 5.54rem;
          top: 0.55rem;
          width: 0.9rem;
          height: 0.3rem;
          background-image: url(/src/views/images/gaoye/address.png);
          background-size: 100% 100%;
          font-size: 0.18rem;
          color: #fff;
          line-height: 0.3rem;
          text-align: center;
        }
        .desc {
          padding-top: 0.58rem;
          font-size 0.24rem
          font-weight bold
          color #000
          line-height 1
          text-align center
        }
        .get {
          position absolute
          left 50%
          margin-left -1.705rem
          top 0.3rem
          width 3.41rem
          height 1.16rem
          background-image url('./images/get.png')
          background-size: 100% 100%
          background-repeat: no-repeat
          background-position: bottom center
          &.disabled {
            filter: grayscale(80%);
            filter: gray;
          }
        }
        .bind {
          position absolute
          left 5.74rem
          top 0.64rem
          width 1.38rem
          height 0.5rem
          background-image url('./images/bind.png')
          background-size: 100% 100%
          background-repeat: no-repeat
          background-position: bottom center
          &.disabled {
            filter: grayscale(100%);
            filter: gray;
          }
        }
        .role {
          line-height: 1;
          position: absolute;
          font-size: 0.2rem;
          font-weight: bold;
          top: 1.46rem;
          text-align: center;
          color: #c8a276;
          width: 100%;
          &-name {
            width: 1.84rem;
            color: #ffe8a2;
            // overflow: hidden;
            // white-space: nowrap;
            // text-overflow: ellipsis;
          }
        }
      }
    }
  }

  .logo {
    z-index: 2
    position: fixed
    top: 0.15rem
    left: 0.26rem
    background-size: 100% auto
    background-repeat:no-repeat
  }

  .prize-pagination {
    position: absolute
    left: 50%
    margin-left: -0.305rem
    top: 5.06rem
    display: flex
    justify-content: space-between
    width: 0.61rem
    height: 0.1rem
    &.lv {
      /deep/.swiper-pagination-bullet {
        &.swiper-pagination-bullet-active {
          background-color: #1c8cd9;
        }
      }
    }

    /deep/.swiper-pagination-bullet {
      display: inline-block
      width: 0.1rem
      opacity: 1
      height: 0.1rem
      background-color #894d1d

      &.swiper-pagination-bullet-active {
        background-color: #cc4717;
      }
    }
  }

  .main-pagination {
    position: fixed
    bottom: 0
    left: 0
    z-index: 2
    display: flex
    justify-content: space-between
    width: 7.5rem
    height: 0.92rem
    height: calc(0.92rem + constant(safe-area-inset-bottom))
    height: calc(0.92rem + env(safe-area-inset-bottom))
    background-color: #1d0101
    padding-bottom: constant(safe-area-inset-bottom)
    padding-bottom: env(safe-area-inset-bottom)
    padding: 0.115rem 0.33rem;
    background-image url('./images/mainPagi.png')
    background-size cover

    .swiper-pagination-bullet {
      display: inline-block
      width: 2.45rem
      opacity: 1
      border-radius 0
      height: 0.69rem
      background: url('./images/menu1.png');
      background-size 100% 100%
      &.active {
        background-image: url('./images/menu1-active.png');
      }
      &-2 {
        background-image: url('./images/menu2.png');
        &.active {
          background-image: url('./images/menu2-active.png');
        }
      }
      &-3 {
        width 1.65rem
        background-image: url('./images/menu3.png');
      }
    }
  }

  .hide
    display: none

@keyframes horse {
  to {
    background-position-y: -29.75rem;
  }
}
@keyframes slideInLeft {
  0% {
    opacity: 0
    transform: translateX(-100%)
  }

  100% {
    opacity: 1
    transform: translateX(0)
  }
}
@keyframes slideInRight {
  0% {
    opacity: 0
    transform: translateX(100%)
  }

  100% {
    opacity: 1
    transform: translateX(0)
  }
}
@keyframes slideInDown {
  0% {
    opacity: 0
    transform: translateY(-100%)
  }

  100% {
    opacity: 1
    transform: translateY(0)
  }
}
@keyframes scaleIn {
  0% {
    opacity: 0
    transform: scale(0)
  }

  100% {
    opacity: 1
    transform: scale(1)
  }
}
@keyframes scale {
  0% {
    transform: scale(1)
  }

  100% {
    transform: scale(1.1)
  }
}

@keyframes rotate {
  to {
    transform: rotate(360deg)
  }
}

@keyframes scaleTr {
  to {
    transform scale(1.2)
  }
}

@keyframes zuoqi {
  to {
    background-position-y: -19.90rem;
  }
}

@media screen and (max-aspect-ratio: 9/16) {
  .main-swiper {
    .swiper-slide {
      .section {
        .frame {
          &.scroll {
            height calc(100vh - 5.85rem) !important
          }
        }
      }

      &.p2 {
        .champion-wrapper {
          height calc(100vh - 8.03rem) !important
        }
      }
    }
  }
}

@media screen and (min-aspect-ratio: 9/16) {
  .main-swiper {
    .swiper-slide {
      .section {
        transform-origin top center
      }
    }
  }
}


@keyframes ani-card-cover-translate {
    0% {
        transform: rotateY(-180deg) scale(1.02) skewY(0deg);
    }

    10% {
        opacity: .5;
    }

    20% {
        opacity: .8;
        transform: rotateY(-180deg) scale(1.1) skewY(0deg);
    }

    30% {
        transform: rotateY(-90deg) scale(1.19) skewY(-12deg);
    }

    70% {
        opacity: 1;
        transform: rotateY(0deg) scale(1.1,1.4) skewY(0deg);
    }

    100% {
        opacity: 1;
        transform: rotateY(0deg) scale(1) skewY(0deg);
    }
}

@keyframes ani-card-back-translate {
    0% {
        transform: rotateY(0deg) scale(1.02) skewY(0deg);
    }

    10% {
        opacity: .5;
    }

    20% {
        opacity: .8;
        transform: rotateY(0deg) scale(1.1) skewY(0deg);
    }

    30% {
        transform: rotateY(-90deg) scale(1.19) skewY(-12deg);
    }

    70% {
        opacity: 1;
        transform: rotateY(-180deg) scale(1.1,1.4) skewY(0deg);
    }

    100% {
        opacity: 1;
        transform: rotateY(-180deg) scale(1) skewY(0deg);
    }
}

@keyframes ani-yellow-card-cover-translate {
    0% {
        transform: rotateY(-180deg) scale(1.02) skewY(0deg) translate(0rpx,0rpx);
    }

    10% {
        opacity: .5;
    }

    20% {
        opacity: .8;
        transform: rotateY(-180deg) scale(1.1) skewY(0deg) translate(0rpx,0rpx);
    }

    30% {
        transform: rotateY(-90deg) scale(1.29) skewY(-12deg);
    }

    70% {
        opacity: 1;
        transform: rotateY(0deg) scale(1.2,1.6) skewY(0deg) translate(10rpx,10rpx);
    }

    100% {
        opacity: 1;
        transform: rotateY(0deg) scale(1) skewY(0deg) translate(0rpx,0rpx);
    }
}

@keyframes ani-yellow-card-back-translate {
    0% {
        transform: rotateY(0deg) scale(1.02) skewY(0deg) translate(0rpx,0rpx);
    }

    10% {
        opacity: .5;
    }

    20% {
        opacity: .8;
        transform: rotateY(0deg) scale(1.1) skewY(0deg) translate(0rpx,0rpx);
    }

    30% {
        transform: rotateY(-90deg) scale(1.29) skewY(-12deg);
    }

    70% {
        opacity: 1;
        transform: rotateY(-180deg) scale(1.2,1.6) skewY(0deg) translate(10rpx,10rpx);
    }

    100% {
        opacity: 1;
        transform: rotateY(-180deg) scale(1) skewY(0deg) translate(0rpx,0rpx);
    }
}
</style>
